import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_SUCCESS,
  editGroupGochiKidMenuPriceShop
} from '../../actions/Groups';
import BatchChangeShopMenuPriceGochiKidModal from '../molecules/BatchChangeShopMenuPriceGochiKidModal';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      groups: state.groups.groups
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          editGroupGochiKidMenuPriceShop
        },
        dispatch
      )
    })
  ),
  withState('openChange', 'updateOpenChange', false)
);

const button = enhance(
  ({ openChange, disabled, updateOpenChange, processV2, groupId, actions }) => {
    const updateChange = () => {
      updateOpenChange(true);
    };

    const updateShopGochiKidMenuPrice = async allowMenuPriceGochiKid => {
      processV2.updateOpenProgressV2(true);
      processV2.updateLoadingV2(true);
      const params = {
        allowMenuPriceGochiKid
      };

      await actions
        .editGroupGochiKidMenuPriceShop(groupId, params)
        .then(async data => {
          if (data.type === EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_SUCCESS) {
            updateOpenChange(false);
            processV2.updateOpenProgressV2(true);
            processV2.setResultMessage('設定更新を完了しました。');
            processV2.updateLoadingV2(false);
          } else {
            processV2.setResultMessage('エラーが発生しました。');
            processV2.updateOpenProgressV2(true);
            processV2.updateLoadingV2(false);
          }
        });
    };

    return (
      <div>
        <Button
          disabled={disabled}
          color="primary"
          onClick={() => updateChange(true)}
        >
          こどもごちめし金額指定利用
        </Button>
        <BatchChangeShopMenuPriceGochiKidModal
          open={openChange}
          onClose={() => {
            updateOpenChange(false);
          }}
          updateShopGochiKidMenuPrice={updateShopGochiKidMenuPrice}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
